import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant' //引入vant组件


import 'vant/lib/index.css' //引入 vant css
import 'amfe-flexible' //引用 amfe-flexible
import './style/index.css' //引用自定义的全局CSS式样文件



createApp(App).use(Vant).use(store).use(router).mount('#app')
